import { useWakenQuery } from "@newHooks/query/msa/waken.query";

export function Waken() {
  useWakenQuery({
    refetchIntervalInBackground: true,
    refetchInterval: 60 * 1000,
  });

  return <div style={{ visibility: "hidden", width: 0, height: 0 }}>Waken: {new Date().toString()}</div>;
}
